"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gate = void 0;
const Defer_1 = require("./Defer");
/*
 * Gate to lock access to some resource.
 */
class Gate {
    pending;
    constructor(isOpen) {
        if (!isOpen) {
            this.close();
        }
    }
    open() {
        this.clearPending();
    }
    close() {
        this.pending ??= new Defer_1.Defer();
    }
    isOpen() {
        return !this.pending;
    }
    clearPending() {
        const { pending } = this;
        if (pending === undefined) {
            return;
        }
        this.pending = undefined;
        pending.resolve(undefined);
    }
    async waitUntilOpen() {
        if (this.pending) {
            await this.pending;
        }
    }
}
exports.Gate = Gate;
//# sourceMappingURL=Gate.js.map